import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';
@Injectable({
  providedIn: 'root'
})
export class InformeAnualService {

  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }
  obtenerInformes(){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/informeAnual',{}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/informeAnual')
          .subscribe((inventario: any) => {
            resolve(inventario)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
  guardarInforme(formData:FormData) {
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/informeAnual/', formData, enviarToken());
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      console.log("entro");
      return this.http.post(CONFIG.API + '/api/informeAnual/', formData).toPromise();
    }
  } 
}
